import Vue from "vue";
import App from "./App.vue";
import routeIndex from "./router";
import routeRegister from "./router/register";
import routeOnboarding from "./router/onboarding";
import store from "./store";
import "./vee-validate";
import Axios from "axios";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import VueFriendlyIframe from "vue-friendly-iframe";
import VueLogger from "vuejs-logger";

Vue.config.productionTip = false;

//set backend URL
if (process.env.VUE_APP_SLOT === "DEV") {
  if (!process.env.VUE_APP_PORT) {
    process.env.VUE_APP_PORT = 3000;
  }
  Axios.defaults.baseURL =
    process.env.VUE_APP_BASE_URL + ":" + process.env.VUE_APP_PORT;

  // console.log(`using backend URL ${Axios.defaults.baseURL}`);
} else {
  Axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
}

//configure logging
const isProduction = process.env.NODE_ENV === "production";
const options = {
  isEnabled: isProduction ? false : true,
  logLevel: "debug",
  stringifyArguments: true,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
};

//set routing
const host = window.location.host;
const parts = host.split(".");
const domainLength = 3; // route1.example.com => domain length = 3
const router = () => {
  let routes;

  if (parts.length === domainLength - 1 || parts[0] === "www") {
    routes = routeIndex;
  } else if (parts[0] === "register" || parts[0] === "register-stage") {
    routes = routeRegister;
  } else if (parts[0] === "onboarding" || parts[0] === "onboarding-stage") {
    routes = routeOnboarding;
  } else {
    // If you want to do something else just comment the line below
    routes = routeIndex;
  }
  return routes;
};

Vue.use(VueFriendlyIframe);
Vue.use(VueLogger, options);

new Vue({
  router: router(),
  store,
  vuetify,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
